export const dataUrlToBlob = (dataUrl) => {
  const [metadata, encoded] = dataUrl.split(',');
  const mimeType = metadata.match(/:(.*?);/)[1];
  const binary = atob(encoded);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return new Blob([bytes], { type: mimeType });
};

export const deliveryTimeToIso = (deliveryTime, now = new Date()) => {
  if (!deliveryTime) return null;
  const [hours, minutes] = deliveryTime.split(':');
  const deliveredAt = new Date(now);
  deliveredAt.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
  return deliveredAt.toISOString();
};

// Freeze the facts once at action admission, including the calendar date. The
// same snapshot can later be saved without turning yesterday's time into today.
export const freezeDeliveryFields = (fields, now = new Date()) => Object.freeze({
  ...fields,
  gpsLocation: fields.gpsLocation ? Object.freeze({ ...fields.gpsLocation }) : null,
  photos: Object.freeze((fields.photos || []).map((photo) => Object.freeze({ ...photo }))),
  video: fields.video ? Object.freeze({ ...fields.video }) : null,
  deliveryTimeIso: fields.deliveryTimeIso !== undefined
    ? fields.deliveryTimeIso : deliveryTimeToIso(fields.deliveryTime, now),
});

export const buildDeliveryEditPayload = ({ receivedBy, receivedByRelationship, notes }) => ({
  received_by: receivedBy.trim(),
  received_by_relationship: receivedByRelationship.trim(),
  notes: notes.trim(),
});

export const buildDeliveryMediaForm = ({ photos, video }) => {
  const form = new FormData();
  photos.forEach((photo) => form.append('photos', photo.file));
  if (video) form.append('video', video.file);
  return form;
};

export const buildDeliveryConfirmationForm = ({
  receivedBy,
  receivedByRelationship,
  notes,
  gpsLocation,
  deliveryTime,
  deliveryTimeIso,
  signatureData,
  photos,
  video,
  now,
}) => {
  const form = new FormData();
  form.append('received_by', receivedBy.trim());
  if (receivedByRelationship.trim()) {
    form.append('received_by_relationship', receivedByRelationship.trim());
  }
  form.append('gps_latitude', gpsLocation?.latitude || 0);
  form.append('gps_longitude', gpsLocation?.longitude || 0);
  if (gpsLocation?.accuracy) form.append('gps_accuracy', gpsLocation.accuracy);
  if (notes.trim()) form.append('notes', notes.trim());
  const deliveredAt = deliveryTimeIso !== undefined ? deliveryTimeIso : deliveryTimeToIso(deliveryTime, now);
  if (deliveredAt) form.append('delivery_time', deliveredAt);
  if (signatureData) form.append('signature', dataUrlToBlob(signatureData), 'signature.png');
  photos.forEach((photo) => form.append('photos', photo.file));
  if (video) form.append('video', video.file);
  return form;
};

export const buildOfflineDeliveryPayload = ({
  orderId,
  receivedBy,
  receivedByRelationship,
  notes,
  gpsLocation,
  deliveryTime,
  deliveryTimeIso,
  signatureData,
  photos,
  video,
  now,
}) => ({
  orderId,
  receivedBy: receivedBy.trim(),
  receivedByRelationship: receivedByRelationship.trim(),
  notes: notes.trim(),
  gpsLatitude: gpsLocation?.latitude ?? null,
  gpsLongitude: gpsLocation?.longitude ?? null,
  gpsAccuracy: gpsLocation?.accuracy ?? null,
  deliveryTime: deliveryTimeIso !== undefined ? deliveryTimeIso : deliveryTimeToIso(deliveryTime, now),
  signature: signatureData ? dataUrlToBlob(signatureData) : null,
  photos: photos.map((photo) => photo.file),
  video: video?.file ?? null,
  coreSent: false,
});
